import type { Auth0Plugin } from '@auth0/auth0-vue';
import { createAuth0 } from '@auth0/auth0-vue';

const auth0Plugin: Auth0Plugin = createAuth0({
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENTID,
  authorizationParams: {
    redirect_uri: window.location.origin + '/callback',
    audience: import.meta.env.VITE_AUTH0_AUDIENCE as string,
    scope: 'openid profile email offline_access',
  },
  useCookiesForTransactions: true,

  useRefreshTokensFallback: true,
  cacheLocation: 'localstorage',
  useRefreshTokens: true,

  onRedirectCallback: (appState) => {
    window.history.replaceState(
      {},
      document.title,
      appState?.targetUrl || window.location.pathname,
    );
  },
});

export default auth0Plugin;

export const getAccessToken = async () => {
  const accessToken = await auth0Plugin.getAccessTokenSilently();
  return accessToken;
};
